import React, { Component, Fragment } from "react";
import { CREATE, GET_LIST, translate, WithPermissions } from "react-admin";
import { connect } from "react-redux";
import {
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tooltip,
  IconButton
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import GetAppIcon from "@material-ui/icons/GetApp";
import UndoIcon from "@material-ui/icons/Undo";
import NotificationsIcon from "@material-ui/icons/Notifications";
import RefreshIcon from "@material-ui/icons/Refresh";
import moment from "moment";
import { setError } from "../../reducer/errorActions";
import { setSuccess } from "../../reducer/successActions";
import download from "downloadjs";
import GenericPopup from "../../components/GenericPopup";
import { togglePopup } from "../../reducer/flagActions";
import restClient from "../../providers/dataProvider/rest";

class InvoiceListPage extends Component {
  state = {
    invoices: [],
    page: 0,
    rowsPerPage: 20,
    totalElements: 0,
    filters: {
      type: "",
      dateFrom: "",
      dateTo: "",
      search: ""
    },
    loading: false,
    creditInvoiceId: null,
    reminderInvoiceId: null
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { page, rowsPerPage, filters } = this.state;
    this.setState({ loading: true });

    restClient(GET_LIST, "invoices", {
      pagination: { page: page + 1, perPage: rowsPerPage },
      sort: { field: "created", order: "ASC" },
      filter: filters
    })
      .then(data => {
        this.setState({
          invoices: data.data || [],
          totalElements: data.total || 0,
          loading: false
        });
      })
      .catch(e => {
        this.setState({ loading: false });
        this.props.dispatch(setError(e));
      });
  };

  handleFilterChange = e => {
    const { name, value } = e.target;
    this.setState(
      prev => ({ filters: { ...prev.filters, [name]: value }, page: 0 }),
      () => this.loadData()
    );
  };

  handleChangePage = (event, page) => {
    this.setState({ page }, () => this.loadData());
  };

  handleChangeRowsPerPage = event => {
    this.setState({ page: 0, rowsPerPage: event.target.value }, () =>
      this.loadData()
    );
  };

  handleExportCsv = () => {
    const { filters } = this.state;

    restClient("GET_CSV", "invoices/csv", {
      filter: filters
    })
      .then(res => {
        return res.blob();
      })
      .then(blob => {
        download(blob, "invoices.csv", "text/csv");
      })
      .catch(e => this.props.dispatch(setError(e)));
  };

  handleCreditClick = invoiceId => {
    this.setState({ creditInvoiceId: invoiceId });
    this.props.dispatch(togglePopup("createCreditPopup"));
  };

  handleCreditConfirm = () => {
    const { creditInvoiceId } = this.state;
    restClient(CREATE, `invoices/${creditInvoiceId}/credit`, {})
      .then(res => {
        if (!res.ok) throw new Error("Credit creation failed");
        return res.json();
      })
      .then(() => {
        this.props.dispatch(setSuccess({ message: "Gutschrift erstellt" }));
        this.props.dispatch(togglePopup("createCreditPopup"));
        this.loadData();
      })
      .catch(e => {
        this.props.dispatch(setError(e));
        this.props.dispatch(togglePopup("createCreditPopup"));
      });
  };

  handleCreditClose = () => {
    this.props.dispatch(togglePopup("createCreditPopup"));
  };

  handleReminderClick = invoiceId => {
    this.setState({ reminderInvoiceId: invoiceId });
    this.props.dispatch(togglePopup("sendReminderPopup"));
  };

  handleReminderConfirm = () => {
    const { reminderInvoiceId } = this.state;
    restClient(CREATE, `invoices/${reminderInvoiceId}/reminder`, {})
      .then(res => {
        if (!res.ok) throw new Error("Reminder sending failed");
        return res;
      })
      .then(() => {
        this.props.dispatch(
          setSuccess({ message: "Zahlungserinnerung gesendet" })
        );
        this.props.dispatch(togglePopup("sendReminderPopup"));
      })
      .catch(e => {
        this.props.dispatch(setError(e));
        this.props.dispatch(togglePopup("sendReminderPopup"));
      });
  };

  handleReminderClose = () => {
    this.props.dispatch(togglePopup("sendReminderPopup"));
  };

  handleClearFilters = () => {
    this.setState(
      { filters: { type: "", dateFrom: "", dateTo: "", search: "" }, page: 0 },
      () => this.loadData()
    );
  };

  hasCreditForNumber = number => {
    return this.state.invoices.some(
      inv => inv.number === number && inv.type === "CREDIT"
    );
  };

  render() {
    const { translate } = this.props;
    const {
      invoices,
      page,
      rowsPerPage,
      totalElements,
      filters,
      loading
    } = this.state;

    return (
      <WithPermissions
        render={({ permissions }) => (
          <Fragment>
            <Typography gutterBottom variant="headline">
              {translate("resources.invoices.title")}
            </Typography>

            <GenericPopup
              open={this.props.createCreditPopup}
              handleClose={this.handleCreditClose}
              handleConfirm={this.handleCreditConfirm}
              title={translate("resources.invoices.creditConfirmTitle")}
              message={translate("resources.invoices.creditConfirmText")}
              confirmText="Ja"
              cancelText="Abbrechen"
            />

            <GenericPopup
              open={this.props.sendReminderPopup}
              handleClose={this.handleReminderClose}
              handleConfirm={this.handleReminderConfirm}
              title={translate("resources.invoices.reminderConfirmTitle")}
              message={translate("resources.invoices.reminderConfirmText")}
              confirmText="Ja"
              cancelText="Abbrechen"
            />

            <Paper style={{ padding: 16, marginBottom: 16 }}>
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  flexWrap: "wrap",
                  alignItems: "center"
                }}
              >
                <TextField
                  label={translate("resources.invoices.search")}
                  name="search"
                  value={filters.search}
                  onChange={this.handleFilterChange}
                  style={{ minWidth: 200 }}
                />
                <FormControl style={{ minWidth: 120 }}>
                  <InputLabel>
                    {translate("resources.invoices.type")}
                  </InputLabel>
                  <Select
                    name="type"
                    value={filters.type}
                    onChange={this.handleFilterChange}
                  >
                    <MenuItem value="">Alle</MenuItem>
                    <MenuItem value="INVOICE">Rechnung</MenuItem>
                    <MenuItem value="CREDIT">Gutschrift</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label={translate("resources.invoices.dateFrom")}
                  name="dateFrom"
                  type="date"
                  value={filters.dateFrom}
                  onChange={this.handleFilterChange}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label={translate("resources.invoices.dateTo")}
                  name="dateTo"
                  type="date"
                  value={filters.dateTo}
                  onChange={this.handleFilterChange}
                  InputLabelProps={{ shrink: true }}
                />
                <Tooltip title="Filter zurücksetzen">
                  <IconButton onClick={this.handleClearFilters}>
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="CSV Export">
                  <IconButton onClick={this.handleExportCsv}>
                    <GetAppIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </Paper>

            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      {translate("resources.invoices.number")}
                    </TableCell>
                    <TableCell>
                      {translate("resources.invoices.type")}
                    </TableCell>
                    <TableCell>
                      {translate("resources.invoices.date")}
                    </TableCell>
                    <TableCell>
                      {translate("resources.invoices.name")}
                    </TableCell>
                    <TableCell>
                      {translate("resources.invoices.competitionName")}
                    </TableCell>
                    <TableCell align="right">
                      {translate("resources.invoices.net")}
                    </TableCell>
                    <TableCell align="right">
                      {translate("resources.invoices.tax")}
                    </TableCell>
                    <TableCell align="right">
                      {translate("resources.invoices.gross")}
                    </TableCell>
                    <TableCell>
                      {translate("resources.invoices.created")}
                    </TableCell>
                    <TableCell>
                      {translate("resources.invoices.actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoices.map(invoice => (
                    <TableRow key={invoice.id}>
                      <TableCell>{invoice.number}</TableCell>
                      <TableCell>
                        {invoice.type === "INVOICE" ? "Rechnung" : "Gutschrift"}
                      </TableCell>
                      <TableCell>
                        {invoice.date
                          ? moment(invoice.date).format("DD.MM.YYYY")
                          : ""}
                      </TableCell>
                      <TableCell>{invoice.name}</TableCell>
                      <TableCell>{invoice.competitionName}</TableCell>
                      <TableCell align="right">
                        {invoice.net != null
                          ? Number(invoice.net).toFixed(2)
                          : ""}
                      </TableCell>
                      <TableCell align="right">
                        {invoice.tax != null
                          ? Number(invoice.tax).toFixed(2)
                          : ""}
                      </TableCell>
                      <TableCell align="right">
                        {invoice.gross != null
                          ? Number(invoice.gross).toFixed(2)
                          : ""}
                      </TableCell>
                      <TableCell>
                        {invoice.created
                          ? moment(invoice.created).format("DD.MM.YYYY HH:mm")
                          : ""}
                      </TableCell>
                      <TableCell>
                        {invoice.type === "INVOICE" &&
                          !this.hasCreditForNumber(invoice.number) && (
                            <Tooltip
                              title={translate(
                                "resources.invoices.createCredit"
                              )}
                            >
                              <IconButton
                                onClick={() =>
                                  this.handleCreditClick(invoice.id)
                                }
                              >
                                <UndoIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        {invoice.type === "INVOICE" && (
                          <Tooltip
                            title={translate("resources.invoices.sendReminder")}
                          >
                            <IconButton
                              onClick={() =>
                                this.handleReminderClick(invoice.id)
                              }
                            >
                              <NotificationsIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                  {invoices.length === 0 && !loading && (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        {translate("resources.invoices.noData")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={totalElements}
                page={page}
                rowsPerPage={rowsPerPage}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 20, 50, 100]}
                labelRowsPerPage="Zeilen pro Seite"
              />
            </Paper>
          </Fragment>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  createCreditPopup: state.flags.popupOpen.createCreditPopup,
  sendReminderPopup: state.flags.popupOpen.sendReminderPopup
});

export default connect(mapStateToProps)(translate(InvoiceListPage));
